"use client"

import { useContext, useEffect, useState, useRef } from "react"
import { Link, NavLink, useNavigate } from "react-router-dom"
import { CircuitoContext } from "../context/CircuitoContext"
import { UserContext } from "../context/UserContext"
import { DomainContext } from "../pages/circuito/LayoutCircuito" // 👈 Importa o novo contexto
import "../styles/navbarCircuito.css"
import { 
  FaBars, FaTimes, FaHome, FaCalendarAlt, FaTrophy, 
  FaUserPlus, FaBook, FaNewspaper, FaUser, FaSignInAlt,
  FaChevronDown, FaIdCard, FaTicketAlt, FaStar, FaSignOutAlt
} from "react-icons/fa"

export default function NavbarCircuito() {
  const navigate = useNavigate()
  const { circuito } = useContext(CircuitoContext)
  const { user, logoutUser } = useContext(UserContext)
  const { basePath } = useContext(DomainContext) // 👈 Puxa o link base dinâmico

  const [drawerOpen, setDrawerOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)

  const logoCircuito = circuito?.imagem
    ? `https://api.ticketdovaqueiro.com/uploads/${circuito.imagem}`
    : null

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  useEffect(() => {
    setDrawerOpen(false)
    setDropdownOpen(false)
  }, [basePath])

  const handleLogout = () => {
    if (logoutUser) {
      logoutUser()
    } else {
      localStorage.removeItem("token")
      localStorage.removeItem("user")
      window.location.reload()
    }
    navigate(`${basePath}/`)
  }

  // 💡 TODOS OS LINKS AGORA SÃO AUTOMÁTICOS
  const navLinks = [
    { to: `${basePath}/`, label: "Início", icon: <FaHome />, end: true },
    { to: `${basePath}/etapas`, label: "Etapas", icon: <FaCalendarAlt /> },
    { to: `${basePath}/ranking`, label: "Ranking", icon: <FaTrophy /> },
    { to: `${basePath}/inscrever-se`, label: "Associe-se", icon: <FaUserPlus /> },
    { to: `${basePath}/regulamento`, label: "Regulamento", icon: <FaBook /> },
    { to: `${basePath}/noticias`, label: "Notícias", icon: <FaNewspaper /> },
  ]

  return (
    <>
      <header className={`cn-header ${scrolled ? "cn-header--scrolled" : ""}`}>
        <div className="cn-header__container">
          <button className="cn-header__mobile-btn" onClick={() => setDrawerOpen(true)}>
            <FaBars />
          </button>

          <Link to={`${basePath}/`} className="cn-header__logo">
            {logoCircuito ? (
              <img src={logoCircuito} alt={circuito?.nome || "Circuito"} />
            ) : (
              <span className="cn-header__logo-fallback">{circuito?.nome || "Circuito"}</span>
            )}
          </Link>

          <nav className="cn-header__nav">
            {navLinks.map((link) => (
              <NavLink key={link.label} to={link.to} end={link.end} className={({ isActive }) => `cn-header__link ${isActive ? "cn-header__link--active" : ""}`}>
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="cn-header__user">
            {user ? (
              <div className="cn-user-menu" ref={dropdownRef}>
                <button className="cn-user-toggle" onClick={() => setDropdownOpen(!dropdownOpen)}>
                  <div className="cn-user-info-text">
                    <span className="cn-user-greeting">Olá,</span>
                    <span className="cn-user-name">{user?.nomeCompleto?.split(" ")[0]}</span>
                  </div>
                  <div className="cn-header__avatar"><FaUser /></div>
                  <FaChevronDown className={`cn-chevron ${dropdownOpen ? "cn-chevron--open" : ""}`} />
                </button>

                <div className={`cn-dropdown ${dropdownOpen ? "cn-dropdown--open" : ""}`}>
                  <div className="cn-dropdown__header">
                    <strong>{user?.nomeCompleto}</strong>
                    <span>{user?.email}</span>
                  </div>
                  <div className="cn-dropdown__body">
                    <Link to={`${basePath}/carteirinha`} className="cn-dropdown__item" onClick={() => setDropdownOpen(false)}><FaIdCard /> Minha Carteirinha</Link>
                    <Link to={`${basePath}/minha-associacao`} className="cn-dropdown__item" onClick={() => setDropdownOpen(false)}><FaIdCard /> Ver Associação</Link>
                    <Link to={`${basePath}/minhas-senhas`} className="cn-dropdown__item" onClick={() => setDropdownOpen(false)}><FaTicketAlt /> Ver Senhas</Link>
                    <Link to={`${basePath}/minha-pontuacao`} className="cn-dropdown__item" onClick={() => setDropdownOpen(false)}><FaStar /> Ver Pontuação</Link>
                    <Link to={`${basePath}/meu-perfil`} className="cn-dropdown__item" onClick={() => setDropdownOpen(false)}><FaUser /> Meu Perfil</Link>
                  </div>
                  <div className="cn-dropdown__footer">
                    <button onClick={handleLogout} className="cn-dropdown__item cn-dropdown__item--danger"><FaSignOutAlt /> Sair da conta</button>
                  </div>
                </div>
              </div>
            ) : (
              <Link to={`${basePath}/inscrever-se/acesso`} className="cn-header__login-btn">
                <FaSignInAlt />
                <span>Entrar</span>
              </Link>
            )}
          </div>
        </div>
      </header>

      <div className={`cn-drawer-overlay ${drawerOpen ? "cn-drawer-overlay--open" : ""}`} onClick={() => setDrawerOpen(false)} />
      
      <aside className={`cn-drawer ${drawerOpen ? "cn-drawer--open" : ""}`}>
        <div className="cn-drawer__header">
          <div className="cn-drawer__brand">
            {logoCircuito && <img src={logoCircuito} alt="Logo" className="cn-drawer__logo" />}
            <span className="cn-drawer__title">{circuito?.nome || "Circuito"}</span>
          </div>
          <button className="cn-drawer__close" onClick={() => setDrawerOpen(false)}><FaTimes /></button>
        </div>

        <nav className="cn-drawer__nav">
          {navLinks.map((link) => (
            <NavLink key={link.label} to={link.to} end={link.end} onClick={() => setDrawerOpen(false)} className={({ isActive }) => `cn-drawer__link ${isActive ? "cn-drawer__link--active" : ""}`}>
              <span className="cn-drawer__link-icon">{link.icon}</span>
              <span>{link.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="cn-drawer__footer">
          {user ? (
            <div className="cn-drawer__user-mobile">
              <div className="cn-drawer__user-header">
                <div className="cn-drawer__avatar"><FaUser /></div>
                <div>
                  <div className="cn-drawer__user-name">{user?.nomeCompleto}</div>
                  <div className="cn-drawer__user-email">{user?.email}</div>
                </div>
              </div>
              <div className="cn-drawer__user-actions">
                <Link to={`${basePath}/carteirinha`} onClick={() => setDrawerOpen(false)} className="cn-drawer__action-link"><FaIdCard /> Carteirinha</Link>
                <Link to={`${basePath}/minha-associacao`} onClick={() => setDrawerOpen(false)} className="cn-drawer__action-link"><FaIdCard /> Associação</Link>
                <Link to={`${basePath}/minhas-senhas`} onClick={() => setDrawerOpen(false)} className="cn-drawer__action-link"><FaTicketAlt /> Senhas</Link>
                <Link to={`${basePath}/minha-pontuacao`} onClick={() => setDrawerOpen(false)} className="cn-drawer__action-link"><FaStar /> Pontuação</Link>
                <Link to={`${basePath}/meu-perfil`} onClick={() => setDrawerOpen(false)} className="cn-drawer__action-link"><FaUser /> Perfil</Link>
                <button onClick={handleLogout} className="cn-drawer__action-btn cn-drawer__action-btn--danger"><FaSignOutAlt /> Sair</button>
              </div>
            </div>
          ) : (
            <Link to={`${basePath}/inscrever-se/acesso`} onClick={() => setDrawerOpen(false)} className="cn-drawer__login-btn">
              <FaSignInAlt />
              <span>Entrar na conta</span>
            </Link>
          )}
        </div>
      </aside>
    </>
  )
}